import React from 'react';
import ContentLoader from 'react-content-loader';

var Loader = function Loader() {
  return /*#__PURE__*/React.createElement(ContentLoader, {
    speed: 2,
    width: 600,
    height: 150,
    viewBox: "0 0 600 150",
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "25",
    rx: "5",
    ry: "5",
    width: "460",
    height: "400"
  }));
};

export default Loader;